module.exports = __webpack_public_path__ + "img/mistockwhite.d684e8f9.png";